// Copyright (c) 2024 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {buildNumber} from '../../shared/services/build-number';

const ModalHeaderCount = props =>
    <header>
        <span>
            <FormattedMessage
                id={props.modalTitle}
                values={{
                    count: buildNumber(props.amountOfUseCount)
                }}
            />
        </span>
        <span
            className='close-modal-icon'
            onClick={props.onCloseButtonClick}
        />
    </header>;

ModalHeaderCount.displayName = 'ModalHeaderCount';
ModalHeaderCount.propTypes = {
    amountOfUseCount: PropTypes.number,
    modalTitle: PropTypes.string.isRequired,
    onCloseButtonClick: PropTypes.func.isRequired
};

export default ModalHeaderCount;



// WEBPACK FOOTER //
// ./src/shared/components/modal-header-with-count.js